import { ApiError } from "./api";

/** Hebrew text for a failure from Firebase Authentication or the API. */
export function errorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    return apiMessage(error);
  }
  const code = (error as { code?: unknown } | null)?.code;
  if (typeof code === "string" && code.startsWith("auth/")) {
    return AUTH_MESSAGES[code] ?? "משהו השתבש בהתחברות. נסו שוב בעוד רגע.";
  }
  return "משהו השתבש. נסו שוב בעוד רגע.";
}

const AUTH_MESSAGES: Record<string, string> = {
  "auth/email-already-in-use": "כבר קיים חשבון עם האימייל הזה. אפשר להתחבר אליו.",
  "auth/invalid-email": "כתובת האימייל לא תקינה.",
  "auth/invalid-credential": "האימייל או הסיסמה שגויים.",
  "auth/wrong-password": "האימייל או הסיסמה שגויים.",
  "auth/user-not-found": "האימייל או הסיסמה שגויים.",
  "auth/user-disabled": "החשבון הושהה. כדי לברר, דברו איתנו.",
  "auth/weak-password": "הסיסמה חלשה מדי. בחרו סיסמה של 8 תווים לפחות.",
  "auth/password-does-not-meet-requirements": "הסיסמה צריכה להיות באורך 8 תווים לפחות.",
  "auth/too-many-requests": "היו יותר מדי ניסיונות. חכו כמה דקות ונסו שוב.",
  "auth/network-request-failed": "אין חיבור לאינטרנט, או שהחיבור נקטע. נסו שוב.",
  "auth/popup-closed-by-user": "חלון ההתחברות נסגר לפני שההתחברות הסתיימה.",
  "auth/popup-blocked": "הדפדפן חסם את חלון ההתחברות. אפשרו חלונות קופצים ונסו שוב.",
  "auth/account-exists-with-different-credential": "כבר קיים חשבון עם האימייל הזה. התחברו עם האימייל והסיסמה.",
  "auth/expired-action-code": "הקישור פג תוקף. בקשו קישור חדש.",
  "auth/invalid-action-code": "הקישור כבר שומש או שאינו תקין. בקשו קישור חדש.",
  "auth/requires-recent-login": "מטעמי אבטחה צריך להתחבר מחדש.",
};

function apiMessage(error: ApiError): string {
  switch (error.code) {
    case "network":
      return "אין חיבור לשרת. בדקו את החיבור לאינטרנט ונסו שוב.";
    case "invalid_profile":
      return error.field === "phone" ? "מספר הטלפון לא תקין." : "נדרש שם מלא: שם פרטי ושם משפחה.";
    case "unknown_plan":
      return "החבילה הזאת לא זמינה כרגע. רעננו את הדף ובחרו שוב.";
    case "unknown_terms_version":
      return "תנאי השימוש עודכנו. רעננו את הדף כדי לאשר את הגרסה החדשה.";
    case "unauthenticated":
      return "פג תוקף ההתחברות. התחברו שוב.";
    case "billing_unavailable":
      return "התשלום באתר עוד לא פתוח. כתבו לנו בוואטסאפ ונפעיל את החבילה.";
    case "already_subscribed":
      return "כבר יש לכם מנוי פעיל. רעננו את הדף כדי לראות אותו.";
    case "payment_declined":
      return "חברת האשראי לא אישרה את החיוב. בדקו את הכרטיס או עדכנו כרטיס אחר.";
    case "payment_provider_error":
      return "חברת הסליקה לא ענתה כרגע. נסו שוב בעוד כמה דקות.";
    case "invalid_tax_id":
      return "מספר ח.פ. או ע.מ. צריך להיות באורך 9 ספרות.";
    case "invalid_invoice_name":
      return "השם לחשבונית קצר מדי.";
    case "profile_incomplete":
      return "צריך להשלים שם וטלפון לפני התשלום.";
    case "terms_required":
      return "תנאי השימוש עודכנו. רעננו את הדף כדי לאשר אותם.";
    case "not_active":
      return "אפשר לשנות חבילה רק במנוי פעיל. אם התשלום האחרון נכשל, עדכנו כרטיס קודם.";
    case "same_plan":
      return "זו כבר החבילה שלכם.";
    case "not_cancelled":
      return "המנוי לא מבוטל.";
    case "no_subscription":
      return "אין מנוי פעיל בחשבון הזה.";
    case "no_card":
      return "אין כרטיס שמור. עדכנו כרטיס ונסו שוב.";
    case "not_activated":
      return "ההורדה נפתחת אחרי הפעלת החשבון. כתבו לנו בוואטסאפ ונפעיל אותו.";
    case "no_release":
      return "קובץ ההתקנה לא זמין כרגע. נסו שוב בעוד כמה דקות, או כתבו לנו בוואטסאפ.";
    default:
      return "משהו השתבש בשרת. נסו שוב בעוד רגע.";
  }
}
